import cloneDeep from 'lodash/cloneDeep';
import { freezeSys, toPlainObject } from 'contentful-sdk-core';
import enhanceWithMethods from '../enhance-with-methods';
import { createDeleteEntity } from '../instance-actions';

function createUploadApi(http) {
  return {
    "delete": createDeleteEntity({
      http: http,
      entityPath: 'uploads'
    })
  };
}
/**
 * @private
 * @param {Object} http - HTTP client instance
 * @param {Object} data - Raw upload data
 * @return {Upload} Wrapped upload data
 */


export function wrapUpload(http, data) {
  var upload = toPlainObject(cloneDeep(data));
  var uploadWithMethods = enhanceWithMethods(upload, createUploadApi(http));
  return freezeSys(uploadWithMethods);
}